module.exports = __webpack_public_path__ + "static/media/update.85dcf1c8.png";